export enum Language {
  EN_US = 'en-US',
  ES_ES = 'es-ES',
  FR_FR = 'fr-FR',
  PT_BR = 'pt-BR',
}
